import { formatCustomDate } from "helpers/dateTools";
import { orderArrayV2 } from "helpers/orderArray";

export const GET_NOTES_FLOTILLA = "GET_NOTES_FLOTILLA";

export const SET_FLOTILLA_INPUTS = "SET_FLOTILLA_INPUTS";

export const RESET_FLOTILLA_STORE = "RESET_FLOTILLA_STORE";

const initialState = {
    notesFlotilla: [],
    startDate: formatCustomDate(new Date(), '-'),
    endDate: formatCustomDate(new Date(), '-'),
    company: null,
    station: [],
    isLoading: false,
}

export const notesFlotillaReducer = (state = initialState, { payload, type }) => {
    switch (type) {
        case GET_NOTES_FLOTILLA: {
            const newPayload = payload.map(n => {
                return {
                    ...n,
                    date: formatCustomDate(n.date, '-')
                }
            })
            const sortPayload = orderArrayV2(newPayload, 'date', true)
            return { ...state, isLoading: false, notesFlotilla: sortPayload };
        }
        case SET_FLOTILLA_INPUTS:
            return { ...state, [payload.key]: payload.value };
        case RESET_FLOTILLA_STORE:
            return initialState;
        default:
            return state
    }
}
